import Banner from "../components/Banner";
import ContactForm from "../components/ContactForm";

function ContactPage() {
  return (
    <div>
      <Banner title="聯絡我們" />
      
      <div className="py-12 px-6 md:px-20 bg-white grid md:grid-cols-2 gap-10">
        {/* 左邊：聯絡資訊 */}
        <div className="space-y-4 font-ec text-textPrimary">
          <h2 className="text-2xl font-bold">和達法律事務所資訊</h2>
          <p>📍 地址：106625 臺北市大安區復興南路二段86號3樓之1</p>
          <p>📞 電話：02-27018356</p>
          <p>📧 信箱：hedalawfirm@gmail.com</p>
          <p>停車場資訊: </p>
          <iframe
              title="停車資訊"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.042176602427!2d121.54094069999998!3d25.032642700000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442abd4c68931f5%3A0x9da9d77a51210616!2z5Zif5Zif5oi_LeWkp-WuiemrmOW3peWcsOS4i-WBnOi7iuWgtA!5e0!3m2!1szh-TW!2stw!4v1756313313405!5m2!1szh-TW!2stw"
              width="80%"
              height="60%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* 右邊：聯絡表單 */}
        <ContactForm />
      </div>
    </div>
  );
}

export default ContactPage;
